export const environment = {
  production: false,
  pre: false,
  qa: true,

  allowedParentOriginOTP: '$(allowedParentOriginOTP)',
  companyContactEmail: 'ewarranty@frederique-constant.com',

  apiClient: 'https://clients.fcqa.ri.dentsutracking.com/qa',
  mfaClient: 'https://auth.fcqa.ri.dentsutracking.com/qa',

  awsMapApiKey: 'v1.public.eyJqdGkiOiIzYTI4YTU2OC0zOTRmLTRiZDgtYWJkMC05YTUyODc1OWRjODkifWgn-Lnqs89zWtBOqzDbjcBQtLqPyBIb5Q4q_tOqBV60MtRuqOvPIUKaJMH18Qt7UgtouITsgjQXXNW20F2N9AUx-i2hEGNQHsJqItD11ypAbr0iU44g1j4Lqs5JFk-yU1a9C-YCIgU1HG73ak6k84rR79T08tPHIeX2OLo1z8nqZHQ2dORgiUZvwc29KeN-6xbLa2aNDhg6cOkq_TI5SiPuPbo7oqWGEcdbabIK4lr3G6K-2GJBFnUlD21VzHIwxY9aJ4aBpzqzfcd7PJ2KTMTkpWEorOGLP5bSUXaNLz3UQ6EhBdjK9GCK1xHl3_mNP78S2fMgcwC4sNtKHxfYQMY.ZGQzZDY2OGQtMWQxMy00ZTEwLWIyZGUtOGVjYzUzMjU3OGE4',
  awsRegion: 'eu-west-1',

  dynamsoft: {
    productKey: 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAwNTAzMjkzLXIxNzM5Mjg3NDYwIiwibWFpblNlcnZlclVSTCI6Imh0dHBzOi8vbWx0cy5keW5hbXNvZnQuY29tLyIsIm9yZ2FuaXphdGlvbklEIjoiMTAwNTAzMjkzIiwic3RhbmRieVNlcnZlclVSTCI6Imh0dHBzOi8vc2x0cy5keW5hbXNvZnQuY29tLyIsImNoZWNrQ29kZSI6NjU1OTIyODg3fQ=='
  }
};
